import Polygon from '@arcgis/core/geometry/Polygon';
import type { Geometry } from 'geojson';

/**
 * Converts a GeoJSON Polygon / MultiPolygon (WGS84 lon/lat) into an ArcGIS
 * Polygon. Returns null for any other geometry type.
 */
export function geoJsonToArcgisPolygon(geometry: Geometry): Polygon | null {
  if (geometry.type === 'Polygon') {
    return new Polygon({ rings: geometry.coordinates });
  }

  if (geometry.type === 'MultiPolygon') {
    return new Polygon({
      rings: geometry.coordinates.flatMap((polygon) => polygon),
    });
  }

  return null;
}
